/**
 * DataFoundationRadialMobile — mobile companion to DataFoundationRadial.
 * Same 8 labels rendered as a compact 2-col grid, shown ONLY on mobile
 * (< sm breakpoint), keeping the visual clean on narrow screens where the
 * absolutely-positioned radial labels would otherwise clip.
 */
export default function DataFoundationRadialMobile({ labels }) {
  return (
    <div className="sm:hidden mt-6 grid grid-cols-2 gap-x-4 gap-y-4 max-w-[420px] mx-auto px-2">
      {labels.map((l, i) => (
        <div key={i} className="flex items-start gap-2">
          <l.icon className="w-3.5 h-3.5 text-sapphire-glow shrink-0 mt-[3px]" />
          <div>
            <div className="font-display text-platinum text-[12px] tracking-tight leading-tight">{l.title}</div>
            <div className="mt-1 text-[10.5px] text-platinum/55 leading-snug">{l.desc}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
